import styled from '@emotion/styled';
import { mediaQueries } from '../../../../style/global-style';

export const StyledWrapper = styled.div`
    background-color: ${(props) => props.theme.colors['main1-70']};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 100%;
`;

export const StyledHeader = styled.h2`
    font-size: ${(props) => props.theme.fontSize.headlineM};
    font-weight: 500;
    line-height: 1.5;
    margin: 0;
    padding: 16px 0 0;

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.headlineXL};
        margin: 0;
        padding: 24px 0 0;
        line-height: normal;
    }
`;

export const StyledContent = styled.p`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    text-align: center;
    margin: 0;
    padding: 7px 12px 16px;
    line-height: 21px;
    max-width: 100%;

    @media ${mediaQueries.tabletAndUp} {
        padding: 19px 64px;
    }
`;
